const slugify = (value) => value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);

const initializePasswordToggles = () => {
    document.querySelectorAll("[data-password-toggle]").forEach((toggleButton) => {
        toggleButton.addEventListener("click", () => {
            const targetSelector = toggleButton.getAttribute("data-password-toggle");
            const passwordField = document.querySelector(targetSelector);

            if (!(passwordField instanceof HTMLInputElement)) {
                return;
            }

            const isVisible = passwordField.type === "text";

            passwordField.type = isVisible ? "password" : "text";
            toggleButton.setAttribute("aria-pressed", String(!isVisible));
            toggleButton.setAttribute("aria-label", isVisible ? "Show password" : "Hide password");

            const toggleLabel = toggleButton.querySelector("[data-password-toggle-label]");

            if (toggleLabel) {
                toggleLabel.textContent = isVisible ? "Show" : "Hide";
            }
        });
    });
};

const initializePasswordStrength = () => {
    document.querySelectorAll("[data-password-strength]").forEach((passwordField) => {
        if (!(passwordField instanceof HTMLInputElement)) {
            return;
        }

        const targetSelector = passwordField.getAttribute("data-password-strength");
        const strengthMeter = document.querySelector(targetSelector);

        if (!(strengthMeter instanceof HTMLElement)) {
            return;
        }

        const strengthLabel = strengthMeter.querySelector("[data-password-strength-label]");
        const strengthValue = strengthMeter.querySelector("[data-password-strength-value]");

        const updateStrength = () => {
            const value = passwordField.value;
            let score = 0;

            if (value.length >= 8) {
                score += 1;
            }

            if (/[A-Z]/.test(value) && /[a-z]/.test(value)) {
                score += 1;
            }

            if (/\d/.test(value)) {
                score += 1;
            }

            if (/[^A-Za-z0-9]/.test(value)) {
                score += 1;
            }

            const states = [
                { label: "Add a stronger password", tone: "idle", width: "0%" },
                { label: "Weak", tone: "weak", width: "25%" },
                { label: "Fair", tone: "fair", width: "50%" },
                { label: "Strong", tone: "strong", width: "75%" },
                { label: "Excellent", tone: "excellent", width: "100%" },
            ];

            const state = value.length === 0 ? states[0] : states[score];

            strengthMeter.dataset.strengthTone = state.tone;
            strengthMeter.style.setProperty("--auth-password-strength", state.width);

            if (strengthLabel) {
                strengthLabel.textContent = state.label;
            }

            if (strengthValue) {
                strengthValue.textContent = value.length === 0 ? "Start typing" : state.label;
            }
        };

        passwordField.addEventListener("input", updateStrength);
        updateStrength();
    });
};

const initializeSlugSync = () => {
    document.querySelectorAll("form").forEach((form) => {
        const sourceField = form.querySelector("[data-slug-source]");
        const slugField = form.querySelector("[data-slug-target]");
        const slugPreview = form.querySelector("[data-slug-preview]");

        if (!(sourceField instanceof HTMLInputElement) || !(slugField instanceof HTMLInputElement)) {
            return;
        }

        let userEditedSlug = (() => {
            const slug = slugField.value.trim();
            const name = sourceField.value.trim();

            return slug.length > 0 && slug !== slugify(name);
        })();

        const updatePreview = () => {
            if (slugPreview) {
                slugPreview.textContent = slugField.value || "your-workspace";
            }
        };

        const syncSlugFromSource = () => {
            if (userEditedSlug) {
                return;
            }

            slugField.value = slugify(sourceField.value);
            updatePreview();
        };

        sourceField.addEventListener("input", syncSlugFromSource);
        sourceField.addEventListener("change", syncSlugFromSource);

        slugField.addEventListener("input", () => {
            userEditedSlug = true;
            slugField.value = slugify(slugField.value);
            updatePreview();
        });

        slugField.addEventListener("blur", () => {
            slugField.value = slugify(slugField.value);

            const slug = slugField.value.trim();
            const name = sourceField.value.trim();

            userEditedSlug = slug.length > 0 && slug !== slugify(name);
            updatePreview();
        });

        syncSlugFromSource();
    });
};

document.addEventListener("DOMContentLoaded", () => {
    initializePasswordToggles();
    initializePasswordStrength();
    initializeSlugSync();
});
